import { render, staticRenderFns } from "./SlideUpMenu.vue?vue&type=template&id=3d89156e&"
import script from "./SlideUpMenu.vue?vue&type=script&lang=js&"
export * from "./SlideUpMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports